import CryptoJS from 'crypto-js';

// Simple storage utilities for ConnectV3 static data approach
export const Storage = {
  // localStorage methods
  setLocal: (key: string, value: any): boolean => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
        return true;
      }
      return false;
    } catch (error) {
      console.warn(`Failed to store '${key}' in localStorage:`, error);
      return false;
    }
  },

  getLocal: (key: string): any => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const item = localStorage.getItem(key);
        if (!item) return null;

        // Try to parse as JSON, fallback to string
        try {
          return JSON.parse(item);
        } catch {
          return item;
        }
      }
      return null;
    } catch (error) {
      console.warn(`Failed to read '${key}' from localStorage:`, error);
      return null;
    }
  },

  // sessionStorage methods
  setSession: (key: string, value: any): boolean => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.setItem(
          key,
          typeof value === 'string' ? value : JSON.stringify(value),
        );
        return true;
      }
      return false;
    } catch (error) {
      console.warn(`Failed to store '${key}' in sessionStorage:`, error);
      return false;
    }
  },

  getSession: (key: string): any => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const item = window.sessionStorage.getItem(key);
        if (!item) return null;

        // Try to parse as JSON, fallback to string
        try {
          return JSON.parse(item);
        } catch {
          return item;
        }
      }
      return null;
    } catch (error) {
      console.warn(`Failed to read '${key}' from sessionStorage:`, error);
      return null;
    }
  },

  // Clear methods
  clearLocal: (): boolean => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.clear();
        return true;
      }
      return false;
    } catch (error) {
      console.warn('Failed to clear localStorage:', error);
      return false;
    }
  },

  clearSession: (): boolean => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.clear();
        return true;
      }
      return false;
    } catch (error) {
      console.warn('Failed to clear sessionStorage:', error);
      return false;
    }
  },

  // Remove methods
  removeLocal: (key: string): boolean => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.removeItem(key);
        return true;
      }
      return false;
    } catch (error) {
      console.warn(`Failed to remove '${key}' from localStorage:`, error);
      return false;
    }
  },

  removeSession: (key: string): boolean => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.removeItem(key);
        return true;
      }
      return false;
    } catch (error) {
      console.warn(`Failed to remove '${key}' from sessionStorage:`, error);
      return false;
    }
  },
};

// For backward compatibility - but discouraged in static data approach
export const StorageUtils = Storage;

export const encryptData = (data: any, salt: string): string => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), salt).toString();
  } catch (err) {
    console.warn('Encryption failed:', err);
    return '';
  }
};

export const decryptData = (ciphertext: string, salt: string): any => {
  const text = ciphertext.replace(/"/g, '');
  try {
    const bytes = CryptoJS.AES.decrypt(text, salt);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (err) {
    console.warn('Decryption failed:', err);
    return null;
  }
};

// ================================================================
// DEPRECATED FUNCTIONS REMOVED
// ================================================================
// All deprecated session storage utilities have been removed.
// Use Redux session management instead:
//
// OLD: addSessionStorage, getSessionStorage, addJSONSessionStorage, getJSONSessionStorage
// NEW: Redux actions: setSession, clearSession, updateActivity
// NEW: Redux selectors: selectSession, selectAuthToken, selectUser
// NEW: Session manager: prepareAuthHeaders, getCurrentAuthToken
//
// Migration guide available in docs/REDUX_SESSION_MANAGEMENT_GUIDE.md
// ================================================================
